(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-values"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-bp-value-toggle]');
  if (!btn) return;
  var card = btn.closest('[data-bp-value-card]');
  if (!card) return;
  var isOpen = card.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-newsletter-popup"]) return;
  try {
    
if (!customElements.get('bp-popup')) {
  customElements.define(
    'bp-popup',
    class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.dialog = this.querySelector('.bp-popup__dialog');
        this.storageKey = 'bp-popup:' + (this.dataset.sectionId || 'default');
        this._onKeydown = function (e) {
          self._handleKey(e);
        };

        this.querySelectorAll('[data-bp-close]').forEach(function (el) {
          el.addEventListener('click', function () {
            self.close();
          });
        });

        var form = this.querySelector('form');
        var consent = this.querySelector('.bp-popup__checkbox');
        if (form && consent && this.dataset.requireConsent === 'true') {
          form.addEventListener('submit', function (e) {
            if (!consent.checked) {
              e.preventDefault();
              self.classList.add('bp-popup--consent-error');
              consent.focus();
            }
          });
          consent.addEventListener('change', function () {
            self.classList.remove('bp-popup--consent-error');
          });
        }

        if (this.querySelector('[data-bp-posted]')) {
          this._remember(true);
          this.open();
          setTimeout(function () {
            self.close(false);
          }, 3000);
          return;
        }

        if (window.Shopify && window.Shopify.designMode) {
          var id = this.dataset.sectionId;
          document.addEventListener('shopify:section:select', function (e) {
            if (e.detail.sectionId === id) self.open();
          });
          document.addEventListener('shopify:section:deselect', function (e) {
            if (e.detail.sectionId === id) self.close(false);
          });
          return;
        }

        if (this.dataset.testMode !== 'true' && this._suppressed()) return;

        var delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
        this._timer = setTimeout(function () {
          self.open();
        }, delay);
      }

      open() {
        if (this._timer) {
          clearTimeout(this._timer);
          this._timer = null;
        }
        this.classList.remove('is-closing');
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        this._prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this._onKeydown);

        var target =
          this.querySelector('[data-bp-autofocus]') ||
          this.querySelector('.bp-popup__input') ||
          this.querySelector('.bp-popup__button');
        window.requestAnimationFrame(function () {
          if (target) target.focus();
        });
      }

      close(remember) {
        var self = this;
        this.classList.remove('is-open');
        this.classList.add('is-closing');
        this.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = this._prevOverflow || '';
        document.removeEventListener('keydown', this._onKeydown);
        if (remember !== false) this._remember(false);

        var dialog = this.querySelector('.bp-popup__dialog');
        function onEnd() {
          dialog.removeEventListener('animationend', onEnd);
          self.classList.remove('is-closing');
        }
        if (dialog) {
          dialog.addEventListener('animationend', onEnd);
        }
        setTimeout(function () {
          self.classList.remove('is-closing');
        }, 600);
      }

      _handleKey(e) {
        if (e.key === 'Escape') {
          this.close();
          return;
        }
        if (e.key !== 'Tab') return;

        var f = this.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'
        );
        if (!f.length) return;

        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      _suppressed() {
        try {
          var ts = parseInt(localStorage.getItem(this.storageKey), 10);
          if (!ts) return false;
          var wasSubscribed = localStorage.getItem(this.storageKey + ':subscribed') === 'true';
          var days = wasSubscribed
            ? parseInt(this.dataset.resubscribeDays, 10) || 0
            : parseInt(this.dataset.frequency, 10) || 0;
          if (days <= 0 && wasSubscribed) return true;
          if (days <= 0) return false;
          return Date.now() - ts < days * 86400000;
        } catch (err) {
          return false;
        }
      }

      _remember(subscribed) {
        try {
          localStorage.setItem(this.storageKey, String(Date.now()));
          if (subscribed) {
            localStorage.setItem(this.storageKey + ':subscribed', 'true');
          }
        } catch (err) {}
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
